import { PERSONNEL_TYPES, ROLES } from 'config/constants';

export const isSponsorInitiator = ({
  groups = [],
  personnelTypes = [],
  recipientRole,
  currentOrganizationId,
} = {}) => {
  if (recipientRole !== ROLES.RESEARCH_SITE) {
    return false;
  }

  const isSponsorAdmin = groups.includes(ROLES.SPONSOR);
  const isSponsorPersonnel =
    groups.includes(ROLES.SPONSOR_PERSONNEL) ||
    (groups.includes(ROLES.PERSONNEL) &&
      personnelTypes.includes(PERSONNEL_TYPES.SPONSOR));

  if (!isSponsorAdmin && !isSponsorPersonnel) {
    return false;
  }

  if (
    !isSponsorAdmin &&
    (groups.includes(ROLES.PERSONNEL) ||
      groups.includes(ROLES.SPONSOR_PERSONNEL)) &&
    !currentOrganizationId
  ) {
    return false;
  }

  return true;
};
